import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, useAppDispatch } from '@/hooks/redux';
import { logout } from '@/store/slices/authSlice';
import { isTokenExpired } from '@/utils';

export function ProtectedRoute() {
  const { isAuthenticated, accessToken, isLoading } = useAuth();
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const checkToken = () => {
      if (accessToken && isTokenExpired(accessToken)) {
        dispatch(logout());
      }
    };

    // Check immediately on route change or mount
    checkToken();

    // Check periodically (every 10 seconds)
    const interval = setInterval(checkToken, 10000);

    return () => clearInterval(interval);
  }, [accessToken, dispatch, location.pathname]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated || (accessToken && isTokenExpired(accessToken))) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
